import React from "react"
import SimpleMessage from "./SimpleMessage.atom"
import { clsx } from "../../utils/strings.utils"

function MessageRect({
  title,
  icon = "pi-paperclip",
  className = "",
  children,
  severity = "info",
}) {
  return (
    <SimpleMessage
      severity={severity}
      className={`mb-3 mt-0 fadein message-rectangle opacity-100 ${className}`}
      content={
        <div className="flex px-2 py-1 w-full gap-3 m-0 ">
          <div>
            <i
              className={clsx(
                "pi text-2xl pt-1",
                icon,
                severity === "success" && "clr-success",
                severity === "info" && "clr-info",
                severity === "warn" && "clr-warning",
                severity === "error" && "clr-error"
              )}
            ></i>
          </div>
          <div className="flex flex-column gap-2 clr-text">
            {title && (
              <span className="text-xl font-semibold font-cairo line-height-1">
                {title}
              </span>
            )}
            {children}
          </div>
        </div>
      }
    />
  )
}

export default MessageRect
